<template>
  <div>
    <!-- <reel-programacion ref="reelRef" :data="listPartidosImagen" /> -->
    <excel
      :categoriaSeleccionada="categoriaSeleccionada || {}"
      :etapa="selectEtapas || {}"
      :grupo="grupoSelectedAux || {}"
      :listEquipos="listTEquiposExcel || []"
      :campeonatoSeleccionado="campeonatoSeleccionado || {}"
      @recargaFixture="recargaFixtureExcel"
    ></excel>
    <config-espejo
      :listEtapas="listEtapas"
      :categoriaSeleccionada="categoriaSeleccionada || {}"
      :etapa="selectEtapas || {}"
      :grupo="grupoSelectedAux || {}"
      :campeonatoSeleccionado="campeonatoSeleccionado || {}"
      :idModalidadGrupoInsert="modalidadGrupo || '0'"
      @recargaFixture="recargaFixture"
    ></config-espejo>
    <modal-finalizar-etapa
      :dataFinalizarEtapa="dataFinalizarEtapa"
      @etapaFinalizada="finalizaEtapa"
    ></modal-finalizar-etapa>
    <delete-fixture
      :dataEliminar="dataFinalizarFixture"
      @eliminadoFixture="recargaFixtureDelete"
      @errorEliminar="errorEliminar"
    ></delete-fixture>
    <print-programacion
      :categoriaSeleccionada="categoriaSeleccionada"
      @partidos="exportarImagenProgramacion($event)"
    ></print-programacion>
    <tabla-posiciones
      :listTablaPosiciones="listTablaPosiciones"
      @updateTabla="showTablaPosiciones"
    ></tabla-posiciones>
    <tabla-goleadores :listTablaGoleadores="listGoleadores"></tabla-goleadores>
    <update-match
      :partido="partidoSeleccionado"
      :canchas="listCanchas"
      :vocales="listVocales"
      :veedores="listVeedores"
      :arbitros="listArbitros"
      :admins="listAdmins"
      :listPlayersLocal="listPlayerLocal"
      :listPlayersVisita="listPlayerVisita"
      :listLocal="listLocal"
      :listVisita="listVisita"
      :listSets="listSets"
      :showLoadingModal="showLoadingModal"
      :categoriaSeleccionada="categoriaSeleccionada"
      :goles_no_presentacion="
        categoriaSeleccionada.goles_no_presentacion || '0'
      "
      :quitar_goles_no_se_presentan="
        categoriaSeleccionada.quitar_goles_no_se_presentan
      "
      @recargar="recargarFixture"
      @nuevoSet="setearSets($event)"
    ></update-match>
    <configuration-group
      @generaFixture="listEquiposToFixture = $event"
      :listEquiposSorteo="listEquiposSorteo"
      :listTeamsAsign="listTeamsAsign"
    >
    </configuration-group>
    <b-card no-body>
      <div class="m-1">
        <b-row>
          <b-col md="3">
            <v-select
              :options="listCampeonatos"
              @input="changeCampeonato"
              placeholder="Selecciona Campeonato"
              :clearable="false"
              v-model="campeonatoSeleccionado"
            />
          </b-col>
          <b-col md="3">
            <v-select
              :options="listCategorias"
              @input="changeCategoria"
              placeholder="Seleccione Categoria"
              :clearable="false"
              v-model="categoriaSeleccionada"
            />
          </b-col>
          <b-col md="3">
            <v-select
              placeholder="Selecciona Etapa"
              @input="changeEtapa"
              :options="listEtapas"
              v-model="selectEtapas"
              :clearable="false"
              class="text-capitalize"
            />
          </b-col>
          <b-col md="1">
            <b-button
              v-if="
                (USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TECNICA) &&
                  !showLoadingNotification &&
                  categoriaSeleccionada.value != null
              "
              v-b-tooltip.hover.v-primary
              title="Enviar notificación"
              variant="flat-primary"
              class="btn-icon"
              @click="sendNotification"
            >
              <feather-icon size="22" icon="SendIcon" />
            </b-button>
            <b-spinner
              v-if="showLoadingNotification"
              variant="success"
              label="Loading..."
              >Enviando</b-spinner
            >
          </b-col>
          <b-col md="1">
            <b-button
              v-b-tooltip.hover.v-primary
              title="Goleadores"
              variant="flat-primary"
              class="btn-icon"
              @click="goleadoresXls"
            >
              <feather-icon size="22" icon="AwardIcon" />
            </b-button>
          </b-col>
          <b-col md="1">
            <b-button
              v-if="
                (USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TECNICA) &&
                  categoriaSeleccionada.value != null
              "
              v-b-tooltip.hover.v-primary
              title="Imprimir hojas Vacias"
              variant="flat-primary"
              class="btn-icon"
              @click="showPrintProgramacion"
            >
              <feather-icon size="22" icon="PrinterIcon" />
            </b-button>
          </b-col>

          <!-- <b-col md="3" class="justify-content-center mb-0 mb-md-0">
            <b-form-group>
              <flat-pickr
                v-b-tooltip.hover.v-primary
                title="Rango de fechas para reportes y programacion"
                v-model="rangeDate"
                class="form-control"
                :config="{ mode: 'range' }"
              />
            </b-form-group>
          </b-col>
          <b-col md="1" class="d-flex justify-content-end  ">
            <b-button
              v-b-tooltip.hover.v-primary
              title="imprimir programacion"
              variant="flat-primary"
              class="btn-icon"
              size="sm"
            >
              <feather-icon size="17" icon="PrinterIcon" />
            </b-button>
            <b-button
              v-b-tooltip.hover.v-primary
              title="imprimir reportes"
              variant="flat-primary"
              class="btn-icon"
              size="sm"
            >
              <feather-icon size="17" icon="ActivityIcon" />
            </b-button>
          </b-col> -->
        </b-row>
      </div>
      <b-tabs v-model="tabIndex" class="mb-1" style="margin-top:-20px">
        <b-tab
          v-for="item in listGrupos"
          :key="item.grupo"
          :title="`${item.nombreGrupo}`"
          @click="changeGrupo(item)"
        >
          <b-row>
            <b-col
              md="7"
              class="d-flex justify-content-start"
              style="margin-top:5px "
              ><b-button
                v-if="item.estado_fixture == 'generado'"
                v-b-tooltip.hover.v-primary
                title="Tabla Posiciones"
                variant="outline-primary"
                class="btn-icon ml-1"
                size="sm"
                @click="showTablaPosiciones"
              >
                <feather-icon size="17" icon="EyeIcon" />
              </b-button>
              <template
                v-if="
                  USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA
                "
              >
                <b-button
                  v-if="item.estado_fixture == 'generar'"
                  v-b-tooltip.hover.v-primary
                  title="Configuración"
                  variant="outline-primary"
                  class="btn-icon ml-1"
                  size="sm"
                  @click="showConfiguration()"
                >
                  <feather-icon size="17" icon="SettingsIcon" />
                </b-button>
                <b-button
                  v-if="
                    item.estado_fixture == 'generar' &&
                      listEquiposToFixture.length != 0
                  "
                  v-b-tooltip.hover.v-primary
                  title="Generar fixture aleaotrio"
                  variant="outline-primary"
                  class="btn-icon ml-1"
                  size="sm"
                  @click="generaFixtureAleatorio"
                >
                  <feather-icon size="17" icon="GridIcon" />
                </b-button>

                <b-button
                  v-if="
                    item.estado_fixture == 'generar' &&
                      listEquiposToFixture.length != 0 &&
                      listPartidosFixture.length != 0 &&
                      !showLoading
                  "
                  v-b-tooltip.hover.v-primary
                  title="Guardar fixture"
                  variant="outline-primary"
                  class="btn-icon ml-1"
                  size="sm"
                  @click="
                    saveFixture(listPartidosFixture, listEquiposToFixture)
                  "
                >
                  <feather-icon size="17" icon="SaveIcon" />
                </b-button>
              </template>
              <template v-if="USER().rol === ROLES.SUPER">
                <b-button
                  v-if="item.espejo != '1' && !showLoading"
                  v-b-tooltip.hover.v-primary
                  title="Generar Espejo"
                  variant="outline-primary"
                  class="btn-icon ml-1"
                  size="sm"
                  @click="showConfigurationEspejo()"
                >
                  <feather-icon size="17" icon="SlackIcon" />
                </b-button>
              </template>
              <template
                v-if="
                  USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA
                "
              >
                <b-button
                  v-if="item.estado_fixture == 'generar' && !showLoading"
                  v-b-tooltip.hover.v-primary
                  title="Fixture por excel"
                  variant="outline-primary"
                  class="btn-icon ml-1"
                  size="sm"
                  @click="showExcel()"
                >
                  <feather-icon size="17" icon="UploadCloudIcon" />
                </b-button>
              </template>
              <template v-if="USER().rol === ROLES.SUPER">
                <b-button
                  v-b-tooltip.hover.v-primary
                  title="Eliminar Fixture"
                  variant="outline-primary"
                  class="btn-icon ml-1"
                  size="sm"
                  @click="showDeleteFixture()"
                >
                  <feather-icon size="17" icon="Trash2Icon" />
                </b-button>
              </template>
            </b-col>
            <b-col md="5" class="d-flex justify-content-end">
              <b-badge class="ml-2" style="height:20px" variant="primary">
                <span>Finalizados</span>
              </b-badge>
              <b-badge class="ml-2" style="height:20px" variant="secondary">
                <span>Por Jugar</span>
              </b-badge>
              <b-badge
                class="ml-2"
                style="height:20px;margin-right:20px; background-color:#b360d1"
                variant="primary"
              >
                <span>Sancionados</span>
              </b-badge>
              <b-badge
                v-if="categoriaSeleccionada.tiene_reset_amarillas"
                class="ml-2"
                style="height:20px;margin-right:20px; "
                variant="danger"
              >
                <span>Reset Amarillas Activo</span>
              </b-badge>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
      <b-overlay :show="showLoading" rounded="sm">
        <div
          v-if="listPartidosFixture.length != 0"
          class="bg-light"
          style="overflow-x:scroll; margin-right:0px; margin-left:0px; height:55vh;"
        >
          <b-row
            v-for="(item, index) in listPartidosFixture"
            :key="item.id"
            style="flex-wrap:nowrap; margin-top:0px; height: 138px;"
          >
            <!-- Primera columna fija -->
            <b-col
              class="fixed-column"
              style="max-width:70px !important; position: sticky; left: 0; background-color: white; z-index: 1;display:flex;align-items:center;font-size: 26px;
    font-weight: bolder;text-align:center;border-bottom: 22px solid #f6f6f6;border-top: 14px solid #f6f6f6"
            >
              <!-- Contenido de la primera columna fija -->
              <div style="width: 40px;">
                <span>{{ index + 1 }}</span>
              </div>
            </b-col>

            <!-- Otras columnas desplazables -->
            <b-col v-for="partido in item.partidos" :key="partido.id">
              <item-partido
                :partido="partido"
                @getDetalleMatch="getDetalleMatch($event)"
              ></item-partido>
            </b-col>
          </b-row>
        </div>
        <div
          v-if="listPartidosFixture.length == 0"
          class="bg-light d-flex justify-content-center"
          style="overflow-x:auto; margin-right:0px; margin-left:0px; height:55vh"
        >
          No existe datos que mostrar
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>
<script>
import vSelect from 'vue-select'
// import flatPickr from 'vue-flatpickr-component'

import {
  BCard,
  //   BFormCheckbox,
  //   BAlert,
  BButton,
  VBTooltip,
  BRow,
  BCol,
  //   BFormInput,
  // BFormGroup,
  BOverlay,
  //   BTable,
  //   BMedia,
  //   BAvatar,
  //   VBTooltip,
  BBadge,
  //   BButtonGroup,
  BTab,
  BTabs,
  BSpinner,
} from 'bootstrap-vue'
import {
  onMounted,
  ref,
  computed,
  watch,
  // xxx,
} from '@vue/composition-api'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import html2canvas from 'html2canvas'

import ItemPartido from './ItemPartido.vue'
import UpdateMatch from './UpdateMatch.vue'
import TablaPosiciones from './TablePosiciones.vue'
import TablaGoleadores from './TableGoleadores.vue'
import ConfigEspejo from './ModalConfigEspejo.vue'
import DeleteFixture from './ModalEliminaFixture.vue'
import Excel from './UploadExcel.vue'

import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  DISCIPLINAS,
  // ACTION_INSERT
} from '../../utils/variables'
import ConfigurationGroup from './ConfigurationGroup.vue'
import ModalFinalizarEtapa from './ModalConfirmacion.vue'
import PrintProgramacion from './PrintProgramacion.vue'
// import ReelProgramacion from './ReelProgramacion.vue'

export default {
  components: {
    BCard,
    vSelect,
    BRow,
    BCol,
    BButton,
    BSpinner,
    // BFormGroup,
    // flatPickr,
    // BButtonGroup,
    BTabs,
    BTab,
    BBadge,
    // BAvatar,
    ItemPartido,
    UpdateMatch,
    ConfigurationGroup,
    BOverlay,
    TablaPosiciones,
    ModalFinalizarEtapa,
    PrintProgramacion,
    TablaGoleadores,
    ConfigEspejo,
    Excel,
    DeleteFixture,
    // ReelProgramacion,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  setup() {
    const rangeDate = ref(null)
    const listCategorias = ref([])
    const listCampeonatos = ref([])
    const listEtapas = ref([])
    const listGrupos = ref([])
    const listEquiposSorteo = ref([])
    const listTeamsAsign = ref([])
    const listEquiposToFixture = ref([])
    const listPartidosFixture = ref([])
    const listPlayerLocal = ref([])
    const listPlayerVisita = ref([])
    const listVocales = ref([])
    const listVeedores = ref([])
    const listArbitros = ref([])
    const listCanchas = ref([])
    const listAdmins = ref([])
    const listLocal = ref([])
    const listVisita = ref([])
    const listSets = ref([])
    const listTablaPosiciones = ref([])
    const listTEquiposExcel = ref([])
    const listGoleadores = ref([])
    const listPartidosImagen = ref([])
    const selectEtapas = ref(null)
    const grupoSelected = ref(null)
    const grupoSelectedAux = ref(null)
    const grupoClick = ref(null)
    const modalidadGrupo = ref(null)
    const showLoading = ref(false)
    const showLoadingNotification = ref(false)
    const showLoadingModal = ref(false)
    const continuar = ref(false)
    const tabIndex = ref(0)
    const reelRef = ref(null)
    const dataFinalizarEtapa = ref({
      id_modalidad_grupo: '',
      id_categoria: '',
      etapa: '',
      grupo: '',
    })
    const dataFinalizarFixture = ref({
      id_modalidad_grupo: '',
      id_categoria: '',
      etapa: '',
      grupo: '',
    })
    const categoriaSeleccionada = ref({
      label: 'Seleccione categoría',
      goles_no_presentacion: '0',
      value: null,
    })
    const campeonatoSeleccionado = ref({
      label: 'Seleccione campeonato',
      value: null,
    })
    const partidoSeleccionado = ref({ categoria: '', respaldos: [] })
    const { getApi, postApi } = apiCall()
    function showPrintProgramacion() {
      store.commit('someVariables/UPDATE_SHOW_PRINT_PROGRAMACION', true)
    }
    function showDeleteFixture() {
      dataFinalizarFixture.value = {
        id_modalidad_grupo: modalidadGrupo.value,
        id_categoria: categoriaSeleccionada.value.value,
        etapa: selectEtapas.value.value,
        grupo: grupoSelected.value,
        id_campeonato: campeonatoSeleccionado.value.value,
      }
      store.commit('someVariables/UPDATE_SHOW_DELETE_FIXTURE', true)
    }
    async function getInstitucionesExcel() {
      // console.log(grupoClick)
      const path = `ApiFixture/getEquiposFixtureExcel/${categoriaSeleccionada.value.value}/`
      const data = await getApi(URL, path)
      listTEquiposExcel.value = data.data
    }
    function showExcel() {
      getInstitucionesExcel()
      store.commit('someVariables/UPDATE_SHOW_UPLOAD_EXCEL_TECNICA', true)
    }

    const exportarImagenProgramacion = async items => {
      listPartidosImagen.value = items
      // await nextTick()

      await reelRef.value.exportar()
    }
    function showFinalizarEtapa() {
      dataFinalizarEtapa.value = {
        id_modalidad_grupo: modalidadGrupo.value,
        id_categoria: categoriaSeleccionada.value.value,
        etapa: selectEtapas.value.value,
        grupo: grupoSelected.value,
      }
      store.commit('someVariables/UPDATE_SHOW_FINALIZAR_ETAPA', true)
    }
    function finalizaEtapa() {
      grupoClick.value.estado = 'd'
    }
    function setearSets(arrayNew) {
      // console.log(arrayNew)
      partidoSeleccionado.value.sets = arrayNew
    }

    async function getListCategorias(idTorneo, idCampeonato) {
      listCategorias.value = []
      const path = `ApiConfiguration/getCategoriasModalidad/${idTorneo}/${idCampeonato}`
      const data = await getApi(URL, path)
      if (data.flag === 's') {
        data.data.forEach(element => {
          const obj = {
            label: `${element.disciplina} ${element.categoria}`,
            value: element.id_categoria,
            etapas: element.etapas,
            id_disciplina: element.id_disciplina,
            name_important: element.name_important,
            goles_no_presentacion: element.goles_no_presentacion,
            quitar_goles_no_se_presentan: element.quitar_goles_no_se_presentan,
            id_categoria: element.id_categoria,
            tiene_reset_amarillas: element.tiene_reset_amarillas,
          }
          listCategorias.value.push(obj)
        })
      } else {
        listCategorias.value = []
      }
    }
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado'],
    )
    function transformCampeonatos(array, salida) {
      array.forEach(element => {
        const obj = {
          label: `${element.anio_inic} - ${element.anio_fin}`,
          value: element.id_campeonato,
          id_torneo: element.id_torneo,
          activo: element.activo,
        }
        salida.value.push(obj)
      })
    }
    watch(cambioTorneo, () => {
      // console.log('watch config')
      categoriaSeleccionada.value = {
        label: 'Seleccione categoría',
        goles_no_presentacion: '0',
      }
      selectEtapas.value = null
      listEtapas.value = []
      listGrupos.value = []
      listPartidosFixture.value = []
      campeonatoSeleccionado.value = null
      listCampeonatos.value = []
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos,
      )
      // const campActivo = listCampeonatos.value.find(
      //   // eslint-disable-next-line
      //   element => element.activo === 's',
      // )
      // campeonatoSeleccionado.value = campActivo
      // getListCategorias(data.id_torneo)
    })
    async function showTablaPosiciones() {
      store.commit('someVariables/UPDATE_SHOW_TABLA_POSICIONES', true)
      // console.log(grupoClick)
      const path = `ApiFixture/getPosiciones/${categoriaSeleccionada.value.value}/${selectEtapas.value.value}/${grupoSelected.value}/${campeonatoSeleccionado.value.value}`
      const data = await getApi(URL, path)
      listTablaPosiciones.value = data.data
    }

    async function goleadoresXls() {
      listGoleadores.value = []
      store.commit('someVariables/UPDATE_SHOW_TABLA_GOLEADORES', true)
      // console.log(grupoClick)
      const path = `ApiFixture/getGoleadores/${categoriaSeleccionada.value.value}/${campeonatoSeleccionado.value.value}`
      const data = await getApi(URL, path)
      listGoleadores.value = data.data
    }
    async function sendNotification() {
      // console.log(categoriaSeleccionada.value)
      showLoadingNotification.value = true
      const path = `ApiFixture/sendNotificacion/PA/${categoriaSeleccionada.value.value}`
      const response = await getApi(URL, path)
      if (response.flag === 'si') {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: `Notificaciones ${categoriaSeleccionada.value.label} enviadas con éxito`,
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'top-right',
            // eslint-disable-next-line
          },
        )
      }
      showLoadingNotification.value = false
    }
    function recargarFixture() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ACTUALIZADO con éxito',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }
    function toArrayCanchas(array) {
      const listReturn = []
      array.forEach(element => {
        const obj = {
          label: `${element.nombre}`,
          value: element.id_cancha,
        }
        listReturn.push(obj)
      })
      return listReturn
    }
    function toArrayVocalesVeedores(array) {
      const listReturn = []
      array.forEach(element => {
        const obj = {
          label: `${element.apodo}`,
          value: element.id_institucion,
        }
        listReturn.push(obj)
      })
      return listReturn
    }
    function toArrayArbitros(array) {
      const listReturn = []
      array.forEach(element => {
        const obj = {
          label: `${element.nombre}`,
          value: element.id_arbitro,
        }
        listReturn.push(obj)
      })
      return listReturn
    }
    function toArrayAdmin(array) {
      const listReturn = []
      array.forEach(element => {
        const obj = {
          label: `${element.apellido} ${element.nombre}`,
          value: element.id_usuario,
        }
        listReturn.push(obj)
      })
      return listReturn
    }
    async function getExtras(idTorneo, idDisciplina) {
      listCanchas.value = []
      listVocales.value = []
      listVeedores.value = []
      listArbitros.value = []
      listAdmins.value = []
      const path = `ApiFixture/getExtras/${idTorneo}/${idDisciplina}`
      const data = await getApi(URL, path)
      listCanchas.value = toArrayCanchas(data.canchas)
      listVocales.value = toArrayVocalesVeedores(data.vocales)
      listVeedores.value = toArrayVocalesVeedores(data.vocales)
      listArbitros.value = toArrayArbitros(data.arbitros)
      listAdmins.value = toArrayAdmin(data.admins)
    }
    async function getEquiposSorteo(idCategoria) {
      listEquiposSorteo.value = []
      const path = `ApiConfiguration/getEquiposSorteo/${idCategoria}`
      const data = await getApi(URL, path)
      if (data.flag === 's') {
        listEquiposSorteo.value = data.data
      } else {
        listEquiposSorteo.value = []
      }
    }
    function changeCampeonato(item) {
      // console.log(item)
      // console.log(categoriaSeleccionada.value)
      listCategorias.value = []
      listGrupos.value = []
      listEtapas.value = []
      listPartidosFixture.value = []
      selectEtapas.value = null
      categoriaSeleccionada.value = {
        label: 'Seleccione categoría',
        goles_no_presentacion: '0',
      }
      getListCategorias(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        // eslint-disable-next-line
        item.value,
      )
      // ID_CATEGORIA.value = item.value
      // item.etapas.forEach(element => {
      //   const obj = {
      //     label: `etapa ${element.etapa}`,
      //     value: element.etapa,
      //     grupos: element.grupos,
      //     id_categoria: item.value,
      //   }
      //   listEtapas.value.push(obj)
      // })
    }
    function changeCategoria(item) {
      // console.log(item)
      // console.log(categoriaSeleccionada.value)
      listEtapas.value = []
      listGrupos.value = []
      listPartidosFixture.value = []
      selectEtapas.value = null
      item.etapas.forEach(element => {
        const obj = {
          label: `etapa ${element.etapa}`,
          value: element.etapa,
          grupos: element.grupos,
          id_categoria: categoriaSeleccionada.value.id_categoria,
        }
        listEtapas.value.push(obj)
      })
      getExtras(
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        // eslint-disable-next-line
        categoriaSeleccionada.value.id_disciplina,
      )
    }
    async function getFixture(idCampeonato, idCategoria, etapa, grupo) {
      listPartidosFixture.value = []
      showLoading.value = true
      const path = `ApiFixture/getFixtureHorariosWeb/${idCampeonato}/${idCategoria}/${etapa}/${grupo}`
      const data = await getApi(URL, path)
      listPartidosFixture.value = data.fechas
      showLoading.value = false
    }
    function changeEtapa(item) {
      // console.log(item)
      tabIndex.value = 0
      listPartidosFixture.value = []
      listGrupos.value = item.grupos
      // eslint-disable-next-line
      grupoSelected.value = item.grupos[0].grupo
      // eslint-disable-next-line
      grupoSelectedAux.value = item.grupos[0]
      // console.log(grupoSelected.value)
      modalidadGrupo.value = item.grupos[0].id_modalidad_grupo
      const [selec] = item.grupos
      grupoClick.value = selec
      const estadoFixture = item.grupos[0].estado_fixture
      if (estadoFixture === 'generado') {
        getFixture(
          campeonatoSeleccionado.value.value,
          categoriaSeleccionada.value.id_categoria,
          selectEtapas.value.value,
          grupoSelected.value,
        )
      }
    }
    function recargaFixtureExcel(item) {
      grupoClick.value.espejo = item.espejo
      grupoClick.value.estado_fixture = 'generado'
      getFixture(
        campeonatoSeleccionado.value.value,
        categoriaSeleccionada.value.value,
        selectEtapas.value.value,
        grupoSelected.value,
      )
    }
    function recargaFixtureDelete() {
      grupoClick.value.estado_fixture = 'generar'
      getFixture(
        campeonatoSeleccionado.value.value,
        categoriaSeleccionada.value.value,
        selectEtapas.value.value,
        grupoSelected.value,
      )
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ELIMINADO con éxito',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }
    function errorEliminar() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ERROR no se puede eliminar existen partidos jugados',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }

    function recargaFixture(item) {
      // console.log(numFechas * 2)
      grupoClick.value.num_fechas = item.numFechas * 2
      grupoClick.value.espejo = item.espejo
      grupoClick.value.estado_fixture = 'generado'
      getFixture(
        campeonatoSeleccionado.value.value,
        categoriaSeleccionada.value.value,
        selectEtapas.value.value,
        grupoSelected.value,
      )
    }
    function changeGrupo(item) {
      // console.log(item)
      grupoClick.value = item
      grupoSelected.value = item.grupo
      grupoSelectedAux.value = item
      modalidadGrupo.value = item.id_modalidad_grupo
      getFixture(
        campeonatoSeleccionado.value.value,
        categoriaSeleccionada.value.value,
        selectEtapas.value.value,
        grupoSelected.value,
      )
      // cargar fixture cuando ya se han generado
    }
    // async function getP() {
    //   const data = await getApi(
    //     'https://turnofacil.ibarra.gob.ec/ApiTurnos/index.php/ApiCliente/getServicesMobile',
    //     '',
    //   )
    //   console.log(data)
    // }
    onMounted(() => {
      // getP()
      // getListCategorias(
      //   // eslint-disable-next-line
      //   store.getters['someVariables/getTorneoSeleccionado'].id_torneo
      // )
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos,
      )
      const campActivo = listCampeonatos.value.find(
        // eslint-disable-next-line
        element => element.activo === 's',
      )
      campeonatoSeleccionado.value = campActivo
      getListCategorias(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        // eslint-disable-next-line
        campeonatoSeleccionado.value.value,
      )
      // changeCampeonato()
      // console.log(campActivo)
    })
    function showConfiguration() {
      store.commit('someVariables/UPDATE_ACTION_CONFIGURATION_GROUP', true)
      getEquiposSorteo(categoriaSeleccionada.value.value)
      // console.log(item)
      // console.log(ID_CATEGORIA.value)
    }
    function showConfigurationEspejo() {
      store.commit('someVariables/UPDATE_SHOW_CONFIG_ESPEJO', true)
      // getEquiposSorteo(ID_CATEGORIA.value)
      // console.log(item)
      // console.log(ID_CATEGORIA.value)
    }
    // function asignarEquipos(teams) {
    //     listEquiposToFixture
    //   console.log(teams)
    // }
    function generarAleatorio(numeroEquipos) {
      const arrayAle = new Array(numeroEquipos)
      for (let i = 0; i < numeroEquipos - 1; i += 1) {
        arrayAle[i] = i
      }
      let i
      let j
      let k
      for (i = numeroEquipos - 1; i; i -= 1) {
        j = Math.floor(Math.random() * i)
        k = arrayAle[i - 1]
        arrayAle[i - 1] = arrayAle[j]
        arrayAle[j] = k
      }
      return arrayAle
    }

    function generateTeamsUse(arrayTeams) {
      // console.log(arrayTeams)
      const teams = []
      for (let i = 0; i <= arrayTeams.length; i += 1) {
        // eslint-disable-next-line
        const team = new Object()
        team.id = i
        team.id_aux = i
        if (i < arrayTeams.length) {
          team.nombre = `${arrayTeams[i].apodo} ${arrayTeams[i].alias_equipo}`
          team.id_equipo = arrayTeams[i].id_equipo
          team.foto = arrayTeams[i].foto
        }
        teams.push(team)
      }
      return teams
    }
    function generarFixtureImpar(teams, arrayAleatorio) {
      const auxNumeroEquipos = teams.length
      const numFechas = auxNumeroEquipos - 1
      const totalPartidosFecha = auxNumeroEquipos / 2
      let aux = 0
      let posicionLocal = 1
      let posicionVisita = auxNumeroEquipos
      const fixture = []
      for (let fecha = 1; fecha <= numFechas; fecha += 1) {
        for (let partido = 1; partido <= totalPartidosFecha; partido += 1) {
          if (partido === totalPartidosFecha) {
            aux = teams[posicionVisita].id
            posicionLocal = aux
            posicionVisita = aux
          } else {
            posicionLocal += 1
            posicionVisita -= 1
            if (posicionLocal === auxNumeroEquipos) {
              posicionLocal = 1
            }
            if (posicionVisita === 0) {
              posicionVisita = auxNumeroEquipos - 1
            }
          }
          if (partido < totalPartidosFecha) {
            const objPartido = {
              numero_fecha: fecha,
              etapa: selectEtapas.value.value,
              grupo: grupoSelected.value,
              id_categoria: categoriaSeleccionada.value.value,
              id_equipo_local:
                teams[arrayAleatorio[posicionLocal - 1]].id_equipo,
              id_equipo_visita:
                teams[arrayAleatorio[posicionVisita - 1]].id_equipo,
              nom_local: teams[arrayAleatorio[posicionLocal - 1]].nombre,
              nom_visita: teams[arrayAleatorio[posicionVisita - 1]].nombre,
              foto_local: teams[arrayAleatorio[posicionLocal - 1]].foto,
              foto_visita: teams[arrayAleatorio[posicionVisita - 1]].foto,
              goles_local: 0,
              goles_visita: 0,
              fecha: '',
              horario: '',
              final: 'PJ',
            }
            fixture.push(objPartido)
          }
        }
      }
      return fixture
    }
    function generarFixturePar(teams, arrayAleatorio) {
      const auxNumeroEquipos = teams.length - 1
      const numFechas = auxNumeroEquipos - 1
      const totalPartidosFecha = auxNumeroEquipos / 2
      let aux = 0
      let posicionLocal = 1
      let posicionVisita = auxNumeroEquipos
      const fixture = []
      for (let fecha = 1; fecha <= numFechas; fecha += 1) {
        for (let partido = 1; partido <= totalPartidosFecha; partido += 1) {
          if (partido === 1) {
            if (fecha % 2 !== 0) {
              const objPartido = {
                numero_fecha: fecha,
                etapa: selectEtapas.value.value,
                grupo: grupoSelected.value,
                id_categoria: categoriaSeleccionada.value.value,
                id_equipo_local:
                  teams[arrayAleatorio[posicionLocal - 1]].id_equipo,
                id_equipo_visita:
                  teams[arrayAleatorio[auxNumeroEquipos - 1]].id_equipo,
                nom_local: teams[arrayAleatorio[posicionLocal - 1]].nombre,
                nom_visita: teams[arrayAleatorio[auxNumeroEquipos - 1]].nombre,
                foto_local: teams[arrayAleatorio[posicionLocal - 1]].foto,
                foto_visita: teams[arrayAleatorio[auxNumeroEquipos - 1]].foto,
                goles_local: 0,
                goles_visita: 0,
                fecha: '',
                horario: '',
                final: 'PJ',
              }
              fixture.push(objPartido)
            } else if (fecha % 2 === 0) {
              const objPartido = {
                numero_fecha: fecha,
                etapa: selectEtapas.value.value,
                grupo: grupoSelected.value,
                id_categoria: categoriaSeleccionada.value.value,
                id_equipo_local:
                  teams[arrayAleatorio[auxNumeroEquipos - 1]].id_equipo,
                id_equipo_visita:
                  teams[arrayAleatorio[posicionVisita - 1]].id_equipo,
                nom_local: teams[arrayAleatorio[auxNumeroEquipos - 1]].nombre,
                nom_visita: teams[arrayAleatorio[posicionVisita - 1]].nombre,
                foto_local: teams[arrayAleatorio[auxNumeroEquipos - 1]].foto,
                foto_visita: teams[arrayAleatorio[posicionVisita - 1]].foto,
                goles_local: 0,
                goles_visita: 0,
                fecha: '',
                horario: '',
                final: 'PJ',
              }
              fixture.push(objPartido)
            }
          } else if (partido !== 1) {
            if (fecha % 2 !== 0) {
              const objPartido = {
                numero_fecha: fecha,
                etapa: selectEtapas.value.value,
                grupo: grupoSelected.value,
                id_categoria: categoriaSeleccionada.value.value,
                id_equipo_local:
                  teams[arrayAleatorio[posicionLocal - 1]].id_equipo,
                id_equipo_visita:
                  teams[arrayAleatorio[posicionVisita - 1]].id_equipo,
                nom_local: teams[arrayAleatorio[posicionLocal - 1]].nombre,
                nom_visita: teams[arrayAleatorio[posicionVisita - 1]].nombre,
                foto_local: teams[arrayAleatorio[posicionLocal - 1]].foto,
                foto_visita: teams[arrayAleatorio[posicionVisita - 1]].foto,
                goles_local: 0,
                goles_visita: 0,
                fecha: '',
                horario: '',
                final: 'PJ',
              }
              fixture.push(objPartido)
            } else if (fecha % 2 === 0) {
              const objPartido = {
                numero_fecha: fecha,
                etapa: selectEtapas.value.value,
                grupo: grupoSelected.value,
                id_categoria: categoriaSeleccionada.value.value,
                id_equipo_local:
                  teams[arrayAleatorio[posicionLocal - 1]].id_equipo,
                id_equipo_visita:
                  teams[arrayAleatorio[posicionVisita - 1]].id_equipo,
                nom_local: teams[arrayAleatorio[posicionLocal - 1]].nombre,
                nom_visita: teams[arrayAleatorio[posicionVisita - 1]].nombre,
                foto_local: teams[arrayAleatorio[posicionLocal - 1]].foto,
                foto_visita: teams[arrayAleatorio[posicionVisita - 1]].foto,
                goles_local: 0,
                goles_visita: 0,
                fecha: '',
                horario: '',
                final: 'PJ',
              }
              fixture.push(objPartido)
            }
          }
          if (partido === totalPartidosFecha) {
            aux = teams[posicionVisita].id
            posicionLocal = aux
            posicionVisita = aux
          } else {
            posicionLocal += 1
            posicionVisita -= 1
            if (posicionLocal === auxNumeroEquipos) {
              posicionLocal = 1
            }
            if (posicionVisita === 0) {
              posicionVisita = auxNumeroEquipos - 1
            }
          }
        }
      }
      return fixture
    }
    function shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1))
        const temp = array[i]
        array[i] = array[j]
        array[j] = temp
      }

      return array
    }

    function randomizarArrayPares(arrayPar) {
      arrayPar.forEach(fecha => {
        shuffleArray(fecha.partidos)
      })
      return arrayPar
    }

    function ordenarFixture(fixture) {
      const fechas = {}

      fixture.forEach(p => {
        if (!fechas[p.numero_fecha]) {
          fechas[p.numero_fecha] = []
        }
        fechas[p.numero_fecha].push(p)
      })

      return Object.keys(fechas)
        .sort((a, b) => a - b)
        .map(f => ({
          numFecha: Number(f),
          partidos: fechas[f],
        }))
    }
    function generaFixtureAleatorio() {
      const teams = generateTeamsUse(listEquiposToFixture.value)
      const numberTeams = listEquiposToFixture.value.length
      // eslint-disable-next-line
      const isPar = numberTeams % 2 === 0 ? true : false
      if (!isPar) {
        const auxNumeroEquipos = numberTeams + 1
        const arrayAleatorio = generarAleatorio(auxNumeroEquipos)
        const fixture = generarFixtureImpar(teams, arrayAleatorio)
        listPartidosFixture.value = ordenarFixture(fixture, numberTeams)
      } else {
        const auxNumeroEquipos = numberTeams + 1
        const arrayAleatorio = generarAleatorio(auxNumeroEquipos)
        const fixture = generarFixturePar(teams, arrayAleatorio)
        const fixtureOrdenado = ordenarFixture(fixture, numberTeams)
        listPartidosFixture.value = randomizarArrayPares(
          // eslint-disable-next-line
          fixtureOrdenado,
        )
      }
    }
    function agregarDataFaltante(listEquipos) {
      listEquipos.forEach(element => {
        element.etapa = selectEtapas.value.value
        element.grupo = grupoSelected.value
      })
    }
    async function saveFixture(partidos, equipos) {
      showLoading.value = true
      agregarDataFaltante(equipos)

      const data = {
        listPartidos: partidos,
        listEquipos: equipos,
        id_modalidad_grupo: modalidadGrupo.value,
        id_campeonato: campeonatoSeleccionado.value.value,
        rol: USER().rol,
      }
      // console.log(data)
      const path = 'ApiFixture/insertFixture'
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        showLoading.value = false
        getFixture(
          campeonatoSeleccionado.value.value,
          categoriaSeleccionada.value.value,
          selectEtapas.value.value,
          grupoSelected.value,
        )
        // categoriaSeleccionada.value.etapas[selectEtapas.value.value]
        grupoClick.value.estado_fixture = 'generado'
        grupoClick.value.num_fechas = partidos.length
        listTeamsAsign.value = []
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'GUARDADO con éxito',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          },
        )
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'ERROR vuelve a intentarlo',
              icon: 'AlertCircleIcon',
              variant: 'error',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          },
        )
      }
    }

    async function getPlayers(idCampeonato, idLocal, idVisita, idPartido) {
      listPlayerLocal.value = []
      listPlayerVisita.value = []
      const path = `ApiInscripciones/getJugadoresEquiposTecnica/${idCampeonato}/${idLocal}/${idVisita}/${idPartido}`
      const data = await getApi(URL, path)
      listPlayerLocal.value = data.local
      listPlayerVisita.value = data.visita
      // console.log(data)
    }
    // async function getDetalleDatabase(idLocal, idVisita, idPartido) {
    //   listPlayerLocal.value = []
    //   listPlayerVisita.value = []
    //   const path = `ApiInscripciones/getJugadoresEquiposTecnica/${idLocal}/${idVisita}/${idPartido}`
    //   const data = await getApi(URL, path)
    //   listPlayerLocal.value = data.local
    //   listPlayerVisita.value = data.visita
    //   console.log(data)
    // }
    function radioNoPresentacion(glnp, gvnp) {
      let valor = null
      if (glnp) {
        valor = 'ganaLocal'
      } else if (gvnp) {
        valor = 'ganaVisita'
      }
      return valor
    }
    async function getDetalleMatch(item) {
      // console.log(item)
      const path = `ApiFixture/getDetallePartido/${item.id_partido}`
      showLoadingModal.value = true
      store.commit('someVariables/UPDATE_SHOW_UPDATE_MATCH', true)
      const data = await getApi(URL, path)
      // console.log(data)
      listLocal.value = data.dataLocal
      listVisita.value = data.dataVisita
      item.name_important = categoriaSeleccionada.value.name_important
      item.id_disciplina = categoriaSeleccionada.value.id_disciplina
      item.id_categoria = categoriaSeleccionada.value.id_categoria
      item.user_modifica = data.partido.user_modifica
      item.motivo = data.partido.motivo
      item.detalle = data.partido.detalle
      item.reset_opcion = data.partido.reset_opcion
      item.act_por = data.partido.act_por
      item.fecha_subida = data.partido.fecha_subida
      item.mostrar_goles_por_sancion = data.partido.mostrar_marcador
      item.voc_revisada = data.partido.voc_revisada
      item.revisado_opc = data.partido.revisado_opc
      item.fecha_revisa = data.partido.fecha_revisa
      item.user_revisa = data.partido.user_revisa
      item.respaldos = data.respaldos || null
      item.permitirBaja = data.permitirBaja
      if (item.id_disciplina === DISCIPLINAS.ECUAVOLEY) {
        // item.sets = data.sets
        listSets.value = data.sets
      }
      // eslint-disable-next-line
      item.glnp = data.partido.final === 'GLNP' ? true : false
      // eslint-disable-next-line
      item.gvnp = data.partido.final === 'GVNP' ? true : false
      item.radioNoPresentacion = radioNoPresentacion(item.glnp, item.gvnp)
      showLoadingModal.value = false
      partidoSeleccionado.value = item
      // console.log(partidoSeleccionado.value)
      // console.log(item)
      getPlayers(
        campeonatoSeleccionado.value.value,
        item.idLocal,
        item.idVisita,
        // eslint-disable-next-line
        item.id_partido,
      )
    }
    return {
      rangeDate,
      showConfiguration,
      showConfigurationEspejo,
      listCategorias,
      listEtapas,
      listEquiposSorteo,
      changeCategoria,
      changeCampeonato,
      selectEtapas,
      changeEtapa,
      listGrupos,
      listEquiposToFixture,
      generaFixtureAleatorio,
      listPartidosFixture,
      listCanchas,
      listVocales,
      listVeedores,
      listArbitros,
      listAdmins,
      listLocal,
      listVisita,
      listSets,
      saveFixture,
      changeGrupo,
      showLoading,
      getFixture,
      getDetalleMatch,
      partidoSeleccionado,
      listPlayerLocal,
      listPlayerVisita,
      categoriaSeleccionada,
      recargarFixture,
      showTablaPosiciones,
      listTablaPosiciones,
      continuar,
      listTeamsAsign,
      USER,
      ROLES,
      showLoadingModal,
      sendNotification,
      showLoadingNotification,
      showFinalizarEtapa,
      dataFinalizarEtapa,
      grupoClick,
      finalizaEtapa,
      showPrintProgramacion,
      setearSets,
      DISCIPLINAS,
      listCampeonatos,
      campeonatoSeleccionado,
      listGoleadores,
      goleadoresXls,
      grupoSelected,
      grupoSelectedAux,
      recargaFixture,
      modalidadGrupo,
      showExcel,
      listTEquiposExcel,
      tabIndex,
      recargaFixtureExcel,
      showDeleteFixture,
      dataFinalizarFixture,
      recargaFixtureDelete,
      errorEliminar,
      listPartidosImagen,
      exportarImagenProgramacion,
      reelRef,
      //   asignarEquipos,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
.nombre-equipo {
  color: gray;
  font-size: 11px;
}
// ::-webkit-scrollbar {
//   display: block;
//   color: red;
// }
::-webkit-scrollbar {
  width: 0px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
